export function initGoogleAnalytics(user) {
    window.gtag('js', new Date());
    window.gtag('config', 'G-TSMRH0YYWR');
    window.gtag('config', 'G-TSMRH0YYWR', {
        user_id: user.email,
    });
    window.gtag('set', 'user_properties', {
        user: "".concat(user.firstName, " ").concat(user.lastName),
        email: user.email,
    });
}
